import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const RetakeVideoPopUp = ({ handleRetakeVideo, setModalRetake }) => {
  return (
    <Dialog open onClose={() => setModalRetake(false)} maxWidth="sm" fullWidth>
      <DialogTitle>
        Retake Video
        <IconButton
          onClick={() => setModalRetake(false)}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography align="center">
          The current video will be deleted and replaced with a new one. Continue?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => setModalRetake(false)}>
          Cancel
        </Button>
        <Button variant="contained" onClick={() => handleRetakeVideo()}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RetakeVideoPopUp;
